import React, { useState } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/fp/get'
import flow from 'lodash/fp/flow'
import first from 'lodash/fp/first'
import getOr from 'lodash/fp/getOr'
import isNil from 'lodash/fp/isNil'
import isEmpty from 'lodash/fp/isEmpty'
import toString from 'lodash/fp/toString'
import Modal from 'components/ui/Modal'
import Input from 'components/ui/forms/Input'
import Select from 'components/ui/forms/Select'
import { REPEAT_INTERVAL } from 'utils/constants'

const ChoresModal = ({ chore, options, setShow, callbacks: { add, edit, remove } }) => {
  const defaultKidId = flow(first, get('value'), toString)(options)
  const [name, setName] = useState(getOr('', 'name', chore))
  const [price, setPrice] = useState(getOr(10, 'price', chore))
  const [kidId, setKidId] = useState(getOr(defaultKidId, 'kidId', chore))
  const [interval, setInterval] = useState(getOr('none', 'repeat.interval', chore))
  const isSaveDisabled = isEmpty(name) || isNil(price) || isNil(kidId) || isNil(interval)

  const onModalSubmitOrCancel = (submitted) => {
    if (!submitted) return

    chore && chore.id
      ? edit({ id: chore.id, name, repeat: { frequency: 1, interval }, price, kidId })
      : add({ name, repeat: { frequency: 1, interval }, price, kidId })
  }

  const onModalDelete = () => {
    remove({ id: chore.id })
    setShow(false)
  }

  return (
    <Modal
      title={isEmpty(chore) ? 'New Chore' : 'Edit Chore'}
      setShow={setShow}
      disabled={isSaveDisabled}
      btnTxtSubmit="Save"
      callback={onModalSubmitOrCancel}
    >
      <Input label="Name" value={name} onChange={setName} />
      <Select
        label="Repeat"
        value={interval}
        onChange={setInterval}
        options={REPEAT_INTERVAL}
      />
      <Input label="Points" value={price} onChange={setPrice} />
      <Select label="Assigned" value={kidId} onChange={setKidId} options={options} />
      {chore && chore.id && (
        <button
          className="absolute mt-6 text-sm text-gray-300 bottom-12 hover:underline hover:text-red-600"
          onClick={onModalDelete}
        >
          Delete
        </button>
      )}
    </Modal>
  )
}

ChoresModal.propTypes = {
  chore: PropTypes.object,
  options: PropTypes.array,
  setShow: PropTypes.func.isRequired,
  callbacks: PropTypes.shape({
    add: PropTypes.func,
    edit: PropTypes.func,
    remove: PropTypes.func,
  }),
}

export default ChoresModal
